// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WiseLabel_componentWrapper__r1+th","new":"WiseLabel_new__KtoqP","promotion":"WiseLabel_promotion__NVPGe","bestseller":"WiseLabel_bestseller__bh0W5"};